import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

// redux
import { raiseToast } from '../toast/toast';

// apis
import { searchBuyerInvoice } from '../../../api/adminAccountBuyer'
import { getBuyerInvoiceItems } from '../../../api/buyerInvoiceItem';
import { getAdjustmentNoteItems } from '../../../api/adjustmentNoteItems';


export const fetchBuyerInvoice = createAsyncThunk('invoice/getBuyerInvoice', async (params, { dispatch }) => {
    let response
    if (params.dataType === "buyerInvoice" || params.dataType === "accountInvoice"){
        response = await searchBuyerInvoice({...params, statusIds: [1, 6]})
    }else if (params.dataType === "creditNotesData"){
        response = await getAdjustmentNoteItems({...params, docNoRequired: true, adjustmentTypeIds: [1, 2]})
    }
    else{
        response = await getBuyerInvoiceItems({...params, docNo: true, joinRequired: true})
    }
    console.log("searchBuyerInvoice response ==> ", response, params)
    if(response.failure){
        dispatch(raiseToast({severity:'error', detail: response.data.error, life: 3000}))
        throw Error()
    }
    if (params.dataType === "buyerInvoice" || params.dataType === "accountInvoice" || params.dataType === "creditNotesData"){
        return response.data
    }else{
        return response
    }
})

export const adminAccountBuyerSlice = createSlice({
    name : "invoice/getBuyerInvoice",
    initialState : {
        loading: false,
        isInitialLoad: true,
        buyerInvoiceData: [],
        paginationParams : {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "buyerInvoice",
            searchBy: "all",
            searchText: "",
            statusId: 1,
            dateType: "createdAt",
            docNo: true
        },
        searchOptions: []
    },
    reducers: {
        setInitialLoad: (state, action) => {
            state.isInitialLoad = action.payload
        },
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
        },
        updateBuyerInvoiceData: (state, action) => {
            state.buyerInvoiceData = action.payload
        }
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchBuyerInvoice.fulfilled, (state, action) => {
                state.loading = false 
                state.buyerInvoiceData = action.payload.data
                state.paginationParams.pageNo = action.payload?.pageNo-1
                state.paginationParams.recordsPerPage = action.payload?.recordsPerPage 
                if(action.payload?.totalRecords || action.payload?.totalRecords === 0){
                    state.paginationParams.totalRecords =  action.payload?.totalRecords
                    state.paginationParams.excessPagesFound = false
                }
                if(action.payload.excessPagesFound || !action.payload.excessPagesFound){
                    if(!state.paginationParams.excessPagesFound){
                        state.paginationParams.excessPagesFound = action.payload.excessPagesFound
                    }else if(action.payload.excessPagesFound === false){
                        state.paginationParams.excessPagesFound = false
                    }
                }
            }
        )
        .addCase(
            fetchBuyerInvoice.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchBuyerInvoice.rejected, (state, action) => {
                state.loading = false
            }
        )
    }

})

export const { updateSearchParams, updateSearchOptions, updateBuyerInvoiceData } = adminAccountBuyerSlice.actions

export default adminAccountBuyerSlice.reducer